// extracted by mini-css-extract-plugin
module.exports = {"container":"RecipientItem-module__container__cNnCp"};